import { ChatApiError } from '../../apiErrors'
import { frontendLanguage } from '../../i18n'
import { QuestionnaireDataError } from './model'

const norwegian = {
  sourceText: 'Samtaletekst for KI-utfylling',
  loading: 'Henter statistikkskjema …',
  loadFailed: 'Kunne ikke hente statistikkskjemaet.',
  unsupportedSchema:
    'Skjemaet har et format som ikke støttes. Hent skjemaet på nytt eller kontakt brukerstøtte.',
  retry: 'Prøv igjen',
  required: 'Dette feltet må fylles ut.',
  invalid: 'Velg et gyldig svar fra skjemaet.',
  exclusive: 'Dette alternativet må stå alene.',
  unknown: 'Svaret tilhører ikke dette skjemaet.',
  validation: 'Kontroller feltene som er markert før du sender inn.',
  autofillFailed:
    'Kunne ikke fylle ut skjemaet med KI. Prøv igjen eller fyll ut manuelt.',
  autofillInvalid:
    'KI returnerte ugyldige svar. Svarene i skjemaet er beholdt. Prøv igjen eller fyll ut manuelt.',
  submitFailed:
    'Kunne ikke bekrefte innsendingen. Svarene i skjemaet er beholdt.',
  submitInvalid:
    'Svarene ble ikke godkjent av tjenesten. Kontroller svarene før du prøver igjen.',
  signIn: 'Logg inn på nytt for å fortsette.',
  forbidden: 'Du har ikke tilgang til statistikkskjemaet.',
  stubNotice:
    'Innsending logger foreløpig bare svarene. Varig lagring er ikke på plass.',
  submitted: 'Svarene er mottatt og logget. De er foreløpig ikke lagret varig.',
}

const english: typeof norwegian = {
  sourceText: 'Conversation text for AI completion',
  loading: 'Loading the questionnaire …',
  loadFailed: 'Could not load the questionnaire.',
  unsupportedSchema:
    'This questionnaire format is not supported. Reload the form or contact support.',
  retry: 'Try again',
  required: 'This field is required.',
  invalid: 'Choose a valid answer from the form.',
  exclusive: 'This option must be selected on its own.',
  unknown: 'This answer does not belong to this questionnaire.',
  validation: 'Check the highlighted fields before submitting.',
  autofillFailed:
    'Could not complete the form with AI. Try again or complete it manually.',
  autofillInvalid:
    'AI returned invalid answers. Your current answers were kept. Try again or complete the form manually.',
  submitFailed:
    'Could not confirm submission. Your answers were kept in the form.',
  submitInvalid:
    'The service did not accept the answers. Check them before trying again.',
  signIn: 'Sign in again to continue.',
  forbidden: 'You do not have access to the questionnaire.',
  stubNotice:
    'Submitting currently only logs the answers. Permanent storage is not available yet.',
  submitted:
    'The answers were received and logged. They have not been permanently saved.',
}

export const questionnaireCopy = frontendLanguage === 'no' ? norwegian : english

export function questionnaireError(
  error: unknown,
  action: 'load' | 'autofill' | 'submit',
): string {
  if (error instanceof QuestionnaireDataError)
    return error.kind === 'schema'
      ? questionnaireCopy.unsupportedSchema
      : questionnaireCopy.autofillInvalid
  if (error instanceof ChatApiError) {
    if (error.status === 401) return questionnaireCopy.signIn
    if (error.status === 403) return questionnaireCopy.forbidden
    if (action === 'autofill' && error.status === 502)
      return questionnaireCopy.autofillInvalid
    if (action === 'submit' && error.status === 400)
      return questionnaireCopy.submitInvalid
  }
  return questionnaireCopy[`${action}Failed`]
}
